import axios from 'axios'
import { config } from './config'

const axiosInstance = axios.create({
  baseURL: config.apiUrl,
  timeout: 15000
})

axiosInstance.interceptors.response.use(
  (response) => {
    const code = response.data.code
    const data = response.data.data
    if (code == '0000') {
      if (process.env.NODE_ENV === 'development') {
        console.log(data)
      }
      return data
    }
    return null
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default axiosInstance
